import React from 'react';
import { PromotionService } from "./PromotionService";
import { useClient } from "../../common/ClientProvider";
import { useAuth0 } from "@auth0/auth0-react";

interface PromotionServiceProviderProps {
    children: React.ReactNode;
}

export const PromotionServiceContext = React.createContext<PromotionService | undefined>(undefined);

export const PromotionServiceProvider: React.FC<PromotionServiceProviderProps> = ({ children }) => {
    const { getAccessTokenSilently } = useAuth0();
    const { currentClientId } = useClient();

    const service = React.useMemo(() => {
        return new PromotionService(getAccessTokenSilently, currentClientId);
    }, [getAccessTokenSilently, currentClientId]);

    return (
        <PromotionServiceContext.Provider value={service}>
            {children}
        </PromotionServiceContext.Provider>
    );
};

export const usePromotionService = (): PromotionService => {
    const context = React.useContext(PromotionServiceContext);
    if (context === undefined) {
        throw new Error('usePromotionService must be used within a PromotionServiceProvider');
    }
    return context;
};
